<template>
  <div class="not-found-view">
  	<div class="header" id='header'>
      <mu-appbar style='background-color: #030329'>
			        <div class="inner" style="margin-left: 90px !important;">
			          <router-link to="/" exact>
			            <img class="logo" src="../assets/topbar_pic_logo.png" alt="logo">
			          </router-link>
			          <router-link to="/" style="">开发者</router-link>      
			          <a to="/doc" href="https://starpos.com.cn/doc/index.html" target='_blank'>|<span style='color:#57CF8D;margin-left: 30px;'>开发者文档</span></a> 
			        </div>
			</mu-appbar>
    </div>
    <h1>404</h1>
  </div>
</template>

<style lang="stylus" scroped>
body {
	font-family: 'Microsoft Yahei', Arial, 'Lantinghei SC', 'Hiragino Sans GB', 'Helvetica Neue', Helvetica, Arial, sans-serif;
	background-color: #ECF3F7 !important;
	margin: 0;
}

a {
	color: #34495e;
	text-decoration: none;
}

.mu-appbar {
	background-color: #03a9f4;
}

.header {
	z-index: 999;
	max-width: 100%;
	height: 55px;
	top: 0;
	left: 0;
	right: 0;
	position: fixed;

	.inner {
		padding-left: 0px;
		padding-bottom: 10px;
		font-size: 16px;
		font-family: 'Microsoft YaHei';

		a {
			color: rgba(255, 255, 255, 0.8);
			line-height: 24px;
			transition: color 0.15s ease;
			display: inline-block;
			vertical-align: middle;
			font-weight: 300;
			letter-spacing: 0.075em;
			margin-right: 1.8em;

			&:hover {
				color: #fff;
			}

			&.router-link-active {
				color: #fff;
				font-weight: 400;
			}
		}
	}

	.icon-contaner {
		cursor: pointer;
	}

	.avatar {
		margin-left: 35px;
		margin-right: 15px;

		img {
			width: 135%;
		}
	}
}

.logo {
	width: 100%;
	margin-right: 10px;
	display: inline-block;
	vertical-align: middle;
}

.view {
	padding: 0 100px;
	margin: 0 auto;
	position: relative;
}

.fade-enter-active, .fade-leave-active {
	transition: all 0.2s ease;
}

.fade-enter, .fade-leave-active {
	opacity: 0;
}

@media (max-width: 860px) {
	.header .inner {
		padding: 15px 30px;
	}
}

@media (max-width: 600px) {
	body {
		font-size: 14px;
	}

	.header {
		.inner {
			padding: 15px;
		}

		a {
			margin-right: 1em;
		}

		.github {
			display: none;
		}
	}
}

/* 个人中心统一样式 */
.personal-center {
	width: 100%;
	margin-top: 50px;
	margin-left: auto;
	margin-right: auto;
	padding: 0;
}

/* padding-bottom 60px */
.menu {
	border: 1px solid #d8d8d8;
	border-radius: 3px;

	h2 {
		margin-top: 0;
		margin-bottom: 0;
		padding: 8px 10px 8px 20px;
		border-bottom: 1px solid #eee;
		border-top-radius: 2px;
		background-color: #f7f7f7;
	}

	.menu-item {
		display: block;
		padding: 8px 10px 8px 8px;
		/* border-bottom 1px solid #eee */
		cursor: pointer;
	}

	a {
		color: #111;
	}
}

.input-button {
	border-radius: 3px;
	width: 102px;
	height: 32px;
	background-color: #eee;
	border: 1px solid #e9e9e9;
	font-size: 14px;
	box-shadow: 0px 1px 1px rgba(0, 0, 0, 0.3);
	cursor: pointer;

	&:hover {
		border: 1px solid #d1d1d1;
	}
}
</style>
<style lang="stylus" scroped>
body {
	font-family: 'Microsoft Yahei', Arial, 'Lantinghei SC', 'Hiragino Sans GB', 'Helvetica Neue', Helvetica, Arial, sans-serif;
	background-color: #ECF3F7 !important;
	margin: 0;
}

a {
	color: #34495e;
	text-decoration: none;
}

.mu-appbar {
	background-color: #03a9f4;
}

.header {
	z-index: 999;
	max-width: 100%;
	height: 55px;
	top: 0;
	left: 0;
	right: 0;
	position: fixed;

	.inner {
		padding-left: 0px;
		padding-bottom: 10px;
		font-size: 16px;
		font-family: 'Microsoft YaHei';

		a {
			color: rgba(255, 255, 255, 0.8);
			line-height: 24px;
			transition: color 0.15s ease;
			display: inline-block;
			vertical-align: middle;
			font-weight: 300;
			letter-spacing: 0.075em;
			margin-right: 1.8em;

			&:hover {
				color: #fff;
			}

			&.router-link-active {
				color: #fff;
				font-weight: 400;
			}
		}
	}

	.icon-contaner {
		cursor: pointer;
	}

	.avatar {
		margin-left: 35px;
		margin-right: 15px;

		img {
			width: 135%;
		}
	}
}

.logo {
	width: 100%;
	margin-right: 10px;
	display: inline-block;
	vertical-align: middle;
}

.view {
	padding: 0 100px;
	margin: 0 auto;
	position: relative;
}

.fade-enter-active, .fade-leave-active {
	transition: all 0.2s ease;
}

.fade-enter, .fade-leave-active {
	opacity: 0;
}

@media (max-width: 860px) {
	.header .inner {
		padding: 15px 30px;
	}
}

@media (max-width: 600px) {
	body {
		font-size: 14px;
	}

	.header {
		.inner {
			padding: 15px;
		}

		a {
			margin-right: 1em;
		}

		.github {
			display: none;
		}
	}
}

/* 个人中心统一样式 */
.personal-center {
	width: 100%;
	margin-top: 50px;
	margin-left: auto;
	margin-right: auto;
	padding: 0;
}

/* padding-bottom 60px */
.menu {
	border: 1px solid #d8d8d8;
	border-radius: 3px;

	h2 {
		margin-top: 0;
		margin-bottom: 0;
		padding: 8px 10px 8px 20px;
		border-bottom: 1px solid #eee;
		border-top-radius: 2px;
		background-color: #f7f7f7;
	}

	.menu-item {
		display: block;
		padding: 8px 10px 8px 8px;
		/* border-bottom 1px solid #eee */
		cursor: pointer;
	}

	a {
		color: #111;
	}
}

.input-button {
	border-radius: 3px;
	width: 102px;
	height: 32px;
	background-color: #eee;
	border: 1px solid #e9e9e9;
	font-size: 14px;
	box-shadow: 0px 1px 1px rgba(0, 0, 0, 0.3);
	cursor: pointer;

	&:hover {
		border: 1px solid #d1d1d1;
	}
}
</style>
<style lang="stylus" scoped>
h1
  font-size 200px
  font-family 'Courgette', cursive
  color #8F8E8C
  text-align center
  margin-bottom 1px
  text-shadow 10px 3px 6px #eee
</style>
<script>

export default {
  	created () {
			var url = location.search;
			if (url.indexOf("?") != -1) { 
				this.$alert(this.GetQueryString('msg'), '', {
	            	confirmButtonText: '确定',
	            	type:'error',
	            	customClass:'alert-box'
	            })
			}
		},
		methods:{
		GetQueryString(name){
	     var reg = new RegExp("(^|&)"+ name +"=([^&]*)(&|$)");
	     var r = window.location.search.substr(1).match(reg);
	     if(r!=null)
	     return  decodeURI(r[2]);
	     return null;
			}
		}
		
}
</script>


// WEBPACK FOOTER //
// src/views/NotFoundView.vue